// SlideRenderer.tsx
import React from "react";

export default function SlideRenderer({ slide, css }) {
  return (
    <div>
      {css && <style dangerouslySetInnerHTML={{ __html: css }} />}
      <div dangerouslySetInnerHTML={{ __html: slide.html || "" }} />
    </div>
  );
}
